<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">

          <!-- Table Header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">{{ title }}</h5>
                <p class="mb-0 text-sm">{{ description }}</p>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                  <router-link
                      v-if="$PickoVersion.isV2()"
                      :to="{ name: 'New order' }"
                      class="mt-2 mb-0 btn bg-gradient-success ms-lg-3 me-lg-0 me-auto mt-lg-0 ">
                    <span>{{ $t('key_orderList_new_record') }}</span>
                  </router-link>
                  <hk-btn-upload-modal :options-format="formatsFile" :url="urlUpload" @success="importSuccess" @failure="importFailure" />
                  <FilterDate :value-date=filters.date @filter-change="onDateFilterChange" @clean-filter-date="onCleanFilterDate"/>
                  <Filter :filter-status-selected="filterStatusSelected" @filter-change="onFilterChange"/>
                  <SgaRegisteredFilter :filter-sga-registered="filters.sga_registered" @sga-registered-filter-change="onFilterSgaRegisteredChange"/>
                  <OutOfStockFilter v-if="$PickoVersion.isV2()" :filter-out-of-stock="filters.out_of_stock" @out-of-stock-filter-change="onFilterOutOfStockChange"/>
                  <soft-button class="btn-icon ms-2 export" size color="primary" variant="outline" data-type="csv" @click="onDownloadExcel">
                    <span class="btn-inner--icon">
                      <i class="fa-solid fa-file-download me-2"></i>
                    </span>
                    <span class="btn-inner--text">{{ $t('key_orderListTableHeader_button_export_order') }}</span>
                  </soft-button>
                  <!-- Interactions with database (filters and reload) -->
                  <ReloadButton :title="$t('key_orderListTableHeader_button_reload_order')" @change="getOrders"/>
                </div>
              </div>
              <div class="mt-4 mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                  <!-- Search space -->
                  <Searchbox :list-filters="listFilters" @change="onSearchChange"/>
                </div>
              </div>
            </div>
          </div>

          <!-- Tabla con los Datos -->
          <GenericTable
            v-if="!!pedidosData"
            ref="genericTable"
            :items="pedidosData.items"
            :list-filters="listFilters"
            :pagination="pagination"
            :headers="headers"
            :is-loading="isLoading"
            @header-changed="onHeaderChange"
            @changed-page="paginationPageChange"
            @row-change="paginationRowChange">
            <template #row="pedido">
              <td style="width: 5rem">
                <div class="d-flex align-items-center">
                  <a style="cursor:pointer" class="mx-3" :title="$t('key_orderList_viewFiles')" data-bs-toggle="modal" data-bs-target="#uploadFolder" @click="loadResource(pedido)">
                    <i v-if="pedido.with_resource && pedido.with_resource == true" class="fa-solid fa-folder-plus text-warning"></i>
                    <i v-else class="fa-solid fa-folder-open text-warning"></i>
                  </a>
                  <FileModalSelector
                    data-bs-backdrop="static"
                    :resources='ordersResource'
                    :entity-id='entityId'
                    :entity-number='entityNumber'
                    :errors='orderErrorResource'
                    :url='urlUploadResource'
                    @success-upload='uploadedResource'
                    @remove-item='removeResource'
                    @close-modal='getOrders'
                  />
                </div>
              </td>
              <td style="width: 20rem" class="text-xs cursor-pointer font-weight-bolder mb-0 picko-link">
                <div class="d-flex">
                  <!-- <div class="my-auto form-check">
                    <input :id="item.id" class="form-check-input" type="checkbox" :checked="selectedIds.includes(item.id)" @change="changedSelection(item.id)" >
                  </div> -->
                  <a class="my-auto ms-3 picko">
                    <a class="font-weight-bold text-primary" href="#" @click.prevent="goToDetalle(pedido)">
                      <i
                          v-if="pedido.sga_registered === false"
                          class="fa-solid fa-triangle-exclamation text-danger me-1"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-original-title="Not synced to SGA yet"
                      ></i>
                      {{ pedido.number }}
                    </a>
                  </a>
                </div>
              </td>
              <!-- <td style="width: 10rem" class="text-sm font-weight-bold">
                <a class="cursor-pointer font-weight-bold mb-0 picko-link" :title="$t('key_orderList_viewOrder')" @click="goToDetalle(pedido)">
                  {{pedido.number}}
                </a>
              </td> -->
              <td class="font-weight-bold">
                <span class="my-2 text-xs columns">{{ pedido.priority }}</span>
              </td>
              <!-- <td class="font-weight-bold">
                <span class="my-2 text-xs columns">{{ pedido.reference }}</span>
              </td> -->
              <td class="font-weight-bold">
                <span class="my-2 text-xs columns">{{ $dateUtils.toDDMMYYYY(pedido.date) }}</span>
              </td>
              <td class="font-weight-bold">
                <span v-if="$PickoVersion.isV1()" class="my-2 text-xs columns">{{ pedido.currier }}</span>
                <span v-if="$PickoVersion.isV2()" class="my-2 text-xs columns">{{ pedido.courier }}</span>
              </td>
              <!--<td style="width: 5%; text-align: center;">
                <span v-if="pedido.batch_control" class="badge badge-info badge-sm">{{ this.$t('key_orderList_batchControl') }}</span>
              </td>
              <td style="width: 5%; text-align: center;">
                <span v-if="pedido.batch_control_date" class="badge badge-info badge-sm">{{ this.$t('key_orderList_batchControlDate') }}</span>
              </td>-->
              <td class="font-weight-bold">
                <span v-if="pedido.status == 'REGISTRADO'" class="badge badge-saved badge-sm">{{ $t('key_orderStatus_saved') }}</span>
                <span v-else-if="pedido.status == 'EN_PROCESO'" class="badge badge-processing badge-sm">{{ $t('key_orderStatus_inProcess') }}</span>
                <span v-else-if="pedido.status == 'EN_ESPERA'" class="badge badge-waitingagent badge-sm">{{ $t('key_orderStatus_waitingAgent') }}</span>
                <span v-else-if="pedido.status == 'FINALIZADO'" class="badge badge-fullfilled badge-sm">{{ $t('key_orderStatus_finished') }}</span>
                <span v-else-if="pedido.status == 'CANCELADO'" class="badge badge-cancelled badge-sm">{{ $t('key_orderStatus_cancelled') }}</span>
                <span v-else-if="pedido.status == 'RETENIDO'" class="badge badge-onhold badge-sm">{{ $t('key_orderStatus_onhold') }}</span>
                <span v-else-if="pedido.status == 'LIBERADO'" class="badge badge-resumed badge-sm">{{ $t('key_orderStatus_resumed') }}</span>
                <span v-else-if="pedido.status == 'RECUPERADO'" class="badge badge-recovered badge-sm">{{ $t('key_orderStatus_recovered') }}</span>
                <span v-else-if="pedido.status == 'REGISTRADO_OL'" class="badge badge-sga badge-sm">{{ $t('key_orderStatus_sga') }}</span>
                <span v-else-if="pedido.status == 'ACTUALIZACION_RESER'" class="badge badge-updatestock badge-sm">{{ $t('key_orderStatus_updatestock') }}</span>
                <span v-else-if="pedido.status == 'RECIBIDO_ALM'" class="badge badge-received badge-sm">{{ $t('key_orderStatus_received') }}</span>
                <span v-else class="badge badge-error badge-sm" :title="pedido.errors">{{ $t('key_orderStatus_notSaved') }}</span>
                <span v-if="pedido.out_of_stock" class="ms-1 text-xs text-outofstock">({{ $t('key_orderStatus_withoutStock') }})</span>
              </td>
              <td class="font-weight-bold">
                <span class="my-2 text-xs columns">{{ pedido.end_customer.name }}</span>
              </td> 
              <td class="units text-xs">
                <ul>
                  <li><span class="my-2 text-xs text-info">{{ $t('key_orderList_orderRequested_units') }}: {{ $numberFormat.toDecimalFormat(pedido.units.requested) }}</span></li>
                  <li><span class="my-2 text-xs text-danger">{{ $t('key_orderList_orderBooked_units') }}: {{ $numberFormat.toDecimalFormat(pedido.units.booked) }}</span></li>
                  <li><span class="my-2 text-xs text-success">{{ $t('key_orderList_orderFinished_units') }}: {{ $numberFormat.toDecimalFormat(pedido.units.completed) }}</span></li>
                </ul>
              </td>
              <td class="text-xs font-weight-bold">
                <span class="my-2 text-xs columns">{{ $dateUtils.toDDMMYYYYHH(pedido.created_at) }}</span>
              </td>
              <td class="text-xs font-weight-bold">
                <!-- <a style="cursor:pointer" class="mx-3" title="Ver pedido" @click="goToDetalle(pedido)">
                  <i class="fa-solid fa-eye text-secondary"></i>
                </a> -->
                <a
                  v-if="$PickoVersion.isV2()"
                  v-show="canEditOrder(pedido)"
                  style="cursor:pointer"
                  class="mx-3"
                  :title="$t('key_orderList_editOrder')"
                  @click="goToEditar(pedido)">
                  <i class="fas fa-edit text-secondary"></i>
                </a>
                <a v-show="pedido.status == 'REGISTRADO' || pedido.status == 'REGISTRADO_OL' || pedido.status == 'LIBERADO' ||
                           pedido.status == 'RETENIDO' || pedido.status == 'RECUPERADO' || pedido.status == 'ACTUALIZACION_RESER' ||
                           pedido.status == 'OUT_OF_STOCK' || pedido.status == 'EN_ESPERA'"
                  style="cursor:pointer"
                  class="mx-3"
                  :title="pedido.on_hold ? $t('key_order_orderAvailable') : $t('key_order_orderOnHold')"
                  data-bs-toggle="modal"
                  data-bs-target="#onHoldModal"
                  @click="onHoldModalData = { ...pedido }">
                  <i :class="{ 'fa-solid fa-pause text-warning': !pedido.on_hold, 'fa-solid fa-play text-primary': pedido.on_hold }"></i>
                </a>
                <a v-show="pedido.status == 'NO_REGISTRADO' || pedido.status == 'REGISTRADO' || pedido.status == 'RETENIDO' ||
                           pedido.status == 'REGISTRADO_OL' || pedido.status == 'LIBERADO' || pedido.status == 'RECUPERADO' ||
                           pedido.status == 'ACTUALIZACION_RESER' || pedido.status == 'OUT_OF_STOCK' || pedido.status == 'EN_ESPERA'"
                  style="cursor:pointer"
                  class="mx-3"
                  :title="$t('key_orderList_cancelOrder')"
                  data-bs-toggle="modal"
                  data-bs-target="#cancelEntityModal"
                  @click="() => entityId = pedido._id">
                  <i class="fa-solid fa-times text-danger"></i>
                </a>
                <a v-show="pedido.status == 'CANCELADO'"
                  style="cursor:pointer"
                  class="mx-3 icon-danger"
                  :title="$t('key_orderList_recoverOrder')"
                  data-bs-toggle="modal"
                  data-bs-target="#recoverEntityModal"
                  @click="() => entityId = pedido._id">
                  <i class="fa-solid fa-arrow-rotate-left text-info"></i>
                </a>
              </td>
            </template>
          </GenericTable>
        </div>
      </div>
    </div>
  </div>
  <ModalCancelConfirmation :entityId='entityId' @cancel-entity="cancelEntity" />
  <ModalRecoverConfirmation :entityId='entityId' @recover-entity="recoverEntity" />
  <ModalOnHold :on-hold-modal-data='onHoldModalData' @confirm-on-hold-status="confirmOnHoldStatus" />
  <div class="position-fixed top-8 end-2 z-index-2">
    <soft-snackbar
      :show="showNotification"
      :title="notificationInfo.title"
      :description="notificationInfo.message"
      :icon="{ component: notificationInfo.status=='success'?'ni ni-check-bold':'ni ni-fat-remove' , color: notificationInfo.status=='success'?'success':'danger' }"
      :color="notificationInfo.status=='success'?'success':'danger'"
      @close-handler="showNotification = !showNotification"
    />
  </div>
</template>

<script>

  import GenericTable from "./../../picko_components/generic_components/GenericTable.vue";
  import ReloadButton from "./../../picko_components/generic_components/ReloadButton.vue";
  import Searchbox from "./../../picko_components/generic_components/Searchbox.vue";
  import SoftButton from "@/components/SoftButton.vue";
  import ModalCancelConfirmation from "@/components/ModalCancelConfirmation.vue";
  import ModalRecoverConfirmation from "@/components/ModalRecoverConfirmation.vue";
  import ModalOnHold from "@/components/ModalOnHold.vue";
  import { HkBtnUploadModal, FileModalSelector } from "@/hotaka/components";
  import SoftSnackbar from "@/components/SoftSnackbar.vue";
  import Filter from "./components/Filter.vue";
  import FilterDate from "../../components/FilterDate.vue";
  import Cookies from 'js-cookie';
  import SgaRegisteredFilter from "@/components/SgaRegisteredFilter.vue";
  import OutOfStockFilter from "@/components/OutOfStockFilter.vue";
  import setTooltip from "@/assets/js/tooltip.js";
  import {PickoVersion} from "../../plugins/PickoVersion";
  import {canEditOrder} from "@/hotaka/js/orderEdit.js";

  export default {
    name: "OrderList",
    components: {
      SoftButton,
      HkBtnUploadModal,
      SoftSnackbar,
      Filter,
      SgaRegisteredFilter,
      OutOfStockFilter,
      FileModalSelector,
      ModalCancelConfirmation,
      ModalRecoverConfirmation,
      ModalOnHold,
      FilterDate,
      GenericTable,
      ReloadButton,
      Searchbox
    },
    data() {
      return {
        filterStatusSelected: '',
        pagination: {
          total: 0,
          rows: 10,
          currentPage: 1,
          pages: {
            total: 10,
            current: 1
          },
          entries: [5, 10, 15, 20, 50]
        },
        options: {
          plugins: {
            legend: {
              display: false
            }
          }
        },
        formatsFile:[
          { label: 'Sevica V2',value: 'SEVICA_V2'},
          { label: 'Sevica',value: 'SEVICA'},
        ],
        urlUpload:"/orders/batch",
        urlUploadResource: "order",
        entityId: null,
        entityNumber: null,
        notificationInfo:{
          title: '',
          message: '',
          status: 'danger'
        },
        isLoading: false,
        showNotification: false,
        filters: {
          search: '',
          status: '',
          sort:{
            sort:'',
            order:''
          },
          date: {
            start: '',
            end: ''
          },
          sga_registered: '',
          out_of_stock: '',
        },
        onHoldModalData: {}
      };
    },
    computed: {
      PickoVersion() {
        return PickoVersion
      },
      pedidosData() {
        return this.$store.state.order.list.data;
      },
      pedidosExcel() {
        return this.$store.state.order.ordersExcel.data;
      },
      ordersResource() {
        return this.$store.state.order.orderResource.data;
      },
      orderErrorResource() {
        return this.$store.state.order.orderResource.error;
      },
      cancel() {
        return this.$store.state.order.cancelEntity.status;
      },
      recover() {
        return this.$store.state.order.recoverEntity.status;
      },
      onHoldStatus() {
        return this.$store.state.order.onHoldStatus.status;
      },
      listFilters() {
        return this.$store.state.order.listFilters;
      },
      headers() {
        return [
          { title: this.$t('key_theader_OrderList_files'), sort: { sorteable: true, order: '' }, column: "with_resource" },
          { title: this.$t('key_theader_OrderList_number') , sort: { sorteable: true, order: ''}, column: "number" },
          { title: this.$t('key_theader_OrderList_priority'), sort: { sorteable: true, order: '' }, column: "priority" },
          //{ title: this.$t('key_theader_OrderList_reference'), sort: { sorteable: true, order: ''}, column: "reference" },
          { title: this.$t('key_theader_OrderList_shippedDate'), sort: { sorteable: true, order: ''}, column: "date" },
          { title: this.$t('key_theader_OrderList_courier'), sort: { sorteable: true, order: ''}, column: this.$PickoVersion.isV1() ? "currier" : "courier" },
          /* { title: this.$t('key_theader_OrderList_batch_control'), sort: { sorteable: true, order: ''}, column: "batch_control" },
          { title: this.$t('key_theader_OrderList_batch_control_date'), sort: { sorteable: true, order: ''}, column: "batch_control_date" }, */
          { title: this.$t('key_theader_OrderList_status'), sort: { sorteable: true, order: ''}, column: "status" },
          { title: this.$t('key_theader_OrderList_end_customer'), sort: { sorteable: true, order: ''}, column: "end_customer" },
          { title: this.$t('key_theader_OrderList_units'), sort: { sorteable: true, order: ''}, column: "units" },
          { title: this.$t('key_theader_OrderList_created_on'), sort: { sorteable: true, order: ''}, column: "created_at" },
          { title: this.$t('key_theader_OrderList_actions'), sort: { sorteable: false, order: ''} }
        ];
      },
      title() {
        return this.$t('key_orderList_table_title');
      },
      description() {
        return this.$t('key_orderList_table_description');
      }
    },
    watch: {
      cancel(val) {
        if (val.canceled) {
          if (this.$store.state.order.cancelEntity.data) {
            this.notificationInfo = {
              title: this.$t('key_mheader_order_cancelled'),
              message: this.$t('key_mmessage_order_cancelled'),
              status: 'success'
            }
            this.showNotification = true;
            this.closeNotification()
            setTimeout(() => {
              this.getOrders();
            }, 1000);
          }
        } else if (val.error) {
          this.showNotification = true;
          this.notificationInfo = {
            title: 'Ups! Error',
            message: val.error,
            status: 'error'
          }
          this.closeNotification()
        }
      },
      recover(val) {
        if (val.recovered) {
          if (this.$store.state.order.recoverEntity.data) {
            this.notificationInfo = {
              title: this.$t('key_mheader_order_recovered'),
              message: this.$t('key_mmessage_order_recovered'),
              status: 'success'
            }
            this.showNotification = true;
            this.closeNotification()
            setTimeout(() => {
              this.getOrders();
            }, 1000);
          }
        } else if (val.error) {
          this.showNotification = true;
          this.notificationInfo = {
            title: 'Ups! Error',
            message: val.error,
            status: 'error'
          }
          this.closeNotification()
        }
      },
      onHoldStatus(val) {
        if (val.onHoldStatus) {
          if (this.$store.state.order.onHoldStatus.data) {
            this.notificationInfo = {
              title: this.onHoldModalData.on_hold ? this.$t('key_mheader_order_available') : this.$t('key_mheader_order_on_hold'),
              message: this.onHoldModalData.on_hold ? this.$t('key_mmessage_order_available') : this.$t('key_mmessage_order_on_hold'),
              status: 'success'
            }
            this.showNotification = true;
            this.closeNotification()
            setTimeout(() => {
              this.getOrders();
            }, 1000);0
          }
        } else if (val.error) {
          this.showNotification = true;
          this.notificationInfo = {
            title: 'Ups! Error',
            message: val.error,
            status: 'error'
          }
          this.closeNotification()
        }
      },
      pedidosData() {
        if(this.pedidosData){
          this.pagination.total= this.pedidosData.total;
          this.isLoading = false;
          this.$nextTick(() => {
            setTooltip(this.$store.state.bootstrap);
          });
        }
      },
      pedidosExcel() {
        if (this.$store.state.order.ordersExcel.error) {
          const error = this.$store.state.order.ordersExcel.error;
          const fr = new FileReader();
          fr.onload = (e) => {
            let excelError = JSON.parse(e.target.result);
            this.notificationInfo = {
              title: 'Ups! Error',
              message: excelError,
              status: 'error'
            }
            this.showNotification = true;
            this.closeNotification();
          };
          fr.readAsText(error);
        }
        else{
          this.downloadExcel(this.pedidosExcel);
          return;
        }
      },
    },
    mounted() {
      this.setUpFilters()
      if (Object.keys(this.$route.query).length > 0) {
        this.filterStatusSelected = this.$route.query.status
        this.filters.status = this.$route.query.status;
      }
      this.getOrders();
    },
    methods: {
      setUpFilters() {
        if (Object.keys(this.listFilters).length == 0) {
          this.defaultRangeDate()
          return
        }

        this.filters = { ...JSON.parse(JSON.stringify(this.listFilters['filters'])) }
        this.pagination = { ...JSON.parse(JSON.stringify(this.listFilters.pagination)) }
        this.headers = this.headers.map(header => {
          let newHeader = { ...header }

          if (this.filters.sort.sort == header.column) {
            newHeader.sort.order = this.filters.sort.order == 'descending' ? 'desc' : 'asc'
          }

          return newHeader
        })
      },
      defaultRangeDate(){
        const fecha = new Date();
    
        const from90 = new Date(
          fecha.getFullYear(),
          fecha.getMonth(),
          fecha.getDate()-90
        );
        const today= new Date(
          fecha.getFullYear(),
          fecha.getMonth(),
          fecha.getDate()
        );
        
        this.filters.date.start=this.$dateUtils.toFormat(from90, 'yyyy-MM-DD');
        this.filters.date.end= this.$dateUtils.toFormat(today,'yyyy-MM-DD');
      },
      cancelEntity(entityId){
        this.$store.commit("order/cancel", entityId);
      },
      recoverEntity(entityId){
        this.$store.commit("order/recover", entityId);
      },
      uploadedResource(upload){
        if (upload['type'] == 'img') {
          this.$store.commit("order/appendImage", upload['entity']);
          return
        }
        this.$store.commit("order/appendDocument", upload['entity']);
      },
      removeResource(contract){
        if (contract['type'] == 'img') {
          this.$store.commit("order/removeImage", contract['entity']);
          return
        }
        this.$store.commit("order/removeDocument", contract['entity']);
      },
      loadResource(entity){
        this.entityId = entity._id
        this.entityNumber = entity.number
        this.$store.commit("order/resetResources");
        this.$store.commit("order/loadResource", entity._id);
      },
      getOrders(){
        if (this.isLoading) return;

        this.isLoading = true;
        this.$store.commit("order/load",{
          filters: this.filters,
          pagination: this.pagination
        });
      },
      paginationPageChange(page) {
        this.pagination.currentPage = page;
        this.getOrders();
      },
      paginationRowChange(rows) {
        this.pagination.rows = rows;
        this.getOrders(); 
      },
      goToDetalle(element) {
        this.$router.push({ path: "/Operations/Orders/OrderDetail/" + element._id});
      },
      goToEditar(element) {
        this.$router.push({ path: "/Operations/Orders/EditOrder/" + element._id});
      },
      canEditOrder(order) {
        return canEditOrder(order);
      },
      getChart(element) {
        let data = {
          labels: [
            'F',
            'P',
            'OS',
          ],
          datasets: [{
            data: [
              element.units.completed, // Finalizadas
              element.units.booked - element.units.completed, //Pendientes
              element.units.requested - element.units.booked // Fuera Stock
            ],
            backgroundColor: [
              'rgb(54, 162, 235)',
              'rgb(255, 205, 86)',
              'rgb(255, 99, 132)',
            ],
            hoverOffset: 4
          }]
        };
        return data;
      },
      importSuccess(){
        this.notificationInfo = {
          title: this.$t('key_mheader_order_imported'),
          message: this.$t('key_mmessage_order_imported'),
          status: 'success'
        }
        this.showNotification = true;
        this.closeNotification();
        setTimeout(() => {
          this.getOrders();
        }, 3000)
      },
      importFailure(status){
        this.notificationInfo = {
          title: 'Ups! Error',
          message: status.error,
          status: 'error'
        }
        this.showNotification = true;
        this.closeNotification()
      },
      closeNotification(){
        const self= this;
        setTimeout(function () {
          self.showNotification = false
        }, 2700);
      },
      onSearchChange(value){
        this.pagination.currentPage = 1;
        this.filters.search=value;
        this.getOrders(); 
      },
      onFilterChange(value){
        this.$router.replace({'query': {}})
        this.filterStatusSelected = value
        this.filters.status=value;
        this.getOrders(); 
      },
      onDateFilterChange(value){
        this.filters.date.start= value.start
        this.filters.date.end= value.end

        this.getOrders();
      },
      onFilterSgaRegisteredChange(value) {
        this.filters.sga_registered = value;
        this.getOrders();
      },
      onFilterOutOfStockChange(value) {
        this.pagination.currentPage = 1;
        this.filters.out_of_stock = value;
        this.getOrders();
      },
      onDownloadExcel() {
        let savedLanguage = Cookies.get('Picko.language') || 'en';
        this.$store.commit("order/ordersExcel", {filters: this.filters, language: savedLanguage});
      },
      downloadExcel(blob) {
        const link = document.createElement("a");
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().split('T')[0];
        link.setAttribute('download', `Orders-${formattedDate}`);
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => {
            URL.revokeObjectURL(link.href);
        }, 100);
      },
      onHeaderChange(val){
        this.filters.sort={
          sort: val.column,
          order: val.order=='asc'? "ascending": "descending"
        }
        this.getOrders(); 
      },
      onCleanFilterDate(){
        this.defaultRangeDate();
        this.getOrders();
      },
      confirmOnHoldStatus(data){
        this.$store.commit("order/onHoldStatus", data);
      }
    },
  };

</script>

<style scoped>

  .units ul {
    list-style-type: none;
    padding: 0rem;
    margin-bottom: 0rem;
  }

</style>